<template>
  <q-card flat :style="$q.screen.lt.md?'':'width: 500px; max-width: 80vw;'">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>سفارش</span> <span>{{ orderInfo.Buy_Num }}</span>
        <template v-slot:action>
          <q-btn icon="close" flat round dense v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding" v-if="issueFactor">
      <q-input dir="ltr" v-model="tax" label="مالیات ارزش فزوده" filled />
    </q-card-section>
    <q-card-section class="no-padding text-center">
      <q-chip square color="indigo" text-color="white" label="تعداد اقلام">
        <q-badge color="red" text-color="white" :label="lodash.sumBy(OrderDetailsList, item=> parseFloat(item.SaleG_Count))"/>
      </q-chip>
      <q-chip  v-if="!isBuyRequest" square color="indigo" text-color="white" label="مبلغ خرید">
        <q-badge color="red" text-color="white" :label="lodash.sumBy(OrderDetailsList, item => parseFloat(item.SaleG_Count) *  parseInt(item.SaleG_PricePure)).toLocaleString()"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="text-center no-padding">
      <q-chip color="indigo" text-color="white" square v-for="(item,index) in groupedList" :key="index"
              :label="item.Group_Name">
        <q-badge class="q-ml-sm" :color="item.sum>0?'green':'red'" text-color="white"
                 :label="`${item.sum.toLocaleString()} ریال`"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding text-center" v-if="issueFactor">
      <q-chip square color="indigo" text-color="white" label="مالیات و ارزش افزوده">
        <q-badge color="red" text-color="white" :label="lodash.sumBy(OrderDetailsList, item => parseFloat(item.SaleG_Count) * parseInt(item.SaleG_Tax)).toLocaleString()"/>
      </q-chip>
      <q-chip square color="indigo" text-color="white" label="تخفیف">
        <q-badge color="red" text-color="white"
                 :label="lodash.sumBy(OrderDetailsList, item => parseFloat(item.SaleG_Count) * parseInt(item.SaleG_Off)).toLocaleString() "/>
      </q-chip>
    </q-card-section>
    <q-card-actions align="center" v-if="issueFactor">
      <q-btn label="صدور فاکتور" @click="issueFactorData" color="primary" icon="check"/>
      <q-btn flat label="انصراف" color="red" icon="cancel" v-close-popup/>
    </q-card-actions>
    <q-card-section class="no-padding">
      <q-table
          :data="OrderDetailsList"
          row-key="Goods_ID"
          wrap-cells
          hide-header
          flat
          :pagination.sync="pagination">
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class">
            <q-td>
              <q-card flat class="q-gutter-xs">
                <q-card-section class="no-padding">
                  <q-chip clickable @click="showProductDetailsDialog(props.row)" square
                          v-if="props.row.Goods_Code!=='109991'" color="indigo" text-color="white"
                          :label="props.row.Goods_Code"/>                </q-card-section>
                <q-card-section class="no-padding">
                  {{ props.row.Goods_Name }}
                  <q-badge color="brown" class="q-ml-xs">{{ props.row.Unit_Name }}</q-badge>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-badge color="indigo" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991' && !issueFactor">
                    {{ props.row.SaleG_Count }}
                  </q-badge>
                  <q-input label="تعداد سفارش"
                           clearable dir="ltr"
                           v-model="props.row.SaleG_Count"
                           v-if="issueFactor" filled>
                  </q-input>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-field
                      v-if="issueFactor"
                      v-model="props.row.SaleG_PricePure"
                      mask="currency"
                      label-color="indigo"
                      autofocus
                      dir="ltr"
                      hide-bottom-space
                      filled
                      dense
                      label="قیمت واحد"
                      clearable
                      lazy-rules
                      :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                    <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                      <input :id="id" class="q-field__native text-right" :value="value"
                             @change="e => emitValue(e.target.value.replaceAll(',',''))"
                             v-money="moneyFormatForDirective"
                             v-show="floatingLabel">
                    </template>
                  </q-field>
                  <q-chip text-color="white" square color="teal" class="q-ml-xs" v-if="!issueFactor && !isBuyRequest">
                    {{ props.row.SaleG_PricePure | toLoalString }}
                    ریال
                  </q-chip>
                  <q-space/>
                  <q-chip :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white" flat
                          label="قیمت کل" v-if="!isBuyRequest">
                    <q-badge color="red-14" class="q-ml-xs">{{ props.row.SaleG_TotalAll | toLoalString }}
                      ریال
                    </q-badge>
                  </q-chip>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-field
                      v-if="issueFactor"
                      v-model="props.row.SaleG_Tax"
                      mask="currency"
                      label-color="indigo"
                      autofocus
                      dir="ltr"
                      filled
                      dense
                      label="مالیات و ارزش افزوده"
                      clearable
                      hide-bottom-space
                      lazy-rules
                      :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                    <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                      <input :id="id" class="q-field__native text-right" :value="value"
                             @change="e => emitValue(e.target.value.replaceAll(',',''))"
                             v-money="moneyFormatForDirective"
                             v-show="floatingLabel">
                    </template>
                    <template v-slot:append>
                      <q-btn icon="attach_money" flat round padding="none" @click="computeTax(props.row)">
                        <q-tooltip>
                          محاسبه مالیات
                        </q-tooltip>
                      </q-btn>
                    </template>
                  </q-field>
                </q-card-section>
                <q-card-section class="no-padding" v-if="props.row.Goods_Code!=='109991'">
                  <q-field
                      v-if="issueFactor"
                      v-model="props.row.SaleG_Off_D"
                      mask="currency"
                      label-color="indigo"
                      autofocus
                      dir="ltr"
                      filled
                      @input="computeSaleGOff(props.row)"
                      dense
                      clearable
                      label="درصد تخفیف"
                      lazy-rules>
                    <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                      <input :id="id" class="q-field__native text-right" :value="value"
                             @change="e => emitValue(e.target.value)"
                             type="number"
                             v-show="floatingLabel">
                    </template>

                  </q-field>
                  <q-field
                      class="q-mt-xs"
                      v-if="issueFactor"
                      v-model="props.row.SaleG_Off"
                      mask="currency"
                      label-color="indigo"
                      autofocus
                      dir="ltr"
                      filled
                      label="مبلغ تخفیف"
                      dense
                      clearable
                      lazy-rules
                      :rules="[
                                    val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                                    val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                                ]">
                    <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                      <input :id="id" class="q-field__native text-right" :value="value"
                             @change="e => emitValue(e.target.value.replaceAll(',',''))"
                             v-money="moneyFormatForDirective"
                             v-show="floatingLabel">
                    </template>

                  </q-field>
                  <q-chip square color="red" v-if="!issueFactor && !isBuyRequest" text-color="white"
                          :label="`${props.row.SaleG_Off} %`"/>
                </q-card-section>
              </q-card>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetails :product="selectedProductDetails"/>
    </q-dialog>

    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "BuyOrderDetailsMobile",
  components: {ProductDetail},
  props: {
    orderInfo: {
      type: Object
    },
    issueFactor: {
      type: Boolean,
      default: false
    },
    isBuyRequest: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      groupedList: [],
      tax:0,
      transportCost: 0,
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      totalOff: 0,
      selectedProductDetails: [],
      showProductDetails: false,
      selectedCustomer: '',
      OrderDetailsList: [],
      pagination: {
        rowsPerPage: 10
      },
    }
  },
  methods: {
    ...mapActions({
      getDetails: 'Buys/getOrderDetails',
      getCustomerInfo: 'Customers/get_customer_info',
      getProductInfo: 'Products/getProductInfo',
      generateFactor: 'Buys/upsertFactor',
      deleteOrderItem: 'Buys/deleteOrderItem'
    }),
    computeSaleGOff(orderItemInfo) {
      orderItemInfo.SaleG_Off = Math.round(parseInt(orderItemInfo.SaleG_PricePure) * (orderItemInfo.SaleG_Off_D/100))
    },
    deleteItem(itemInfo) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'کالا حذف شود؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.deleteOrderItem(
            {
              BuyNum: itemInfo.Buy_Num,
              BuyKind: itemInfo.Buy_Kind,
              GoodsID: itemInfo.Goods_ID
            }).then(() => {
          const founded = this.OrderDetailsList.findIndex(item => item.Goods_ID === itemInfo.Goods_ID)
          this.$delete(this.OrderDetailsList, founded)
        })
      })
    },
    computeTax(orderItemInfo) {
      orderItemInfo.SaleG_Tax =  (orderItemInfo.SaleG_PricePure * this.tax) / 100.00
      orderItemInfo.SaleG_Tax_D = this.tax;
    },
    issueFactorData() {
      const sendObject = {
        Factor_Num: 'NULL',
        Buy_Num: this.orderInfo.Buy_Num,
        Buy_Kind: this.orderInfo.Buy_Kind,
        items: this.OrderDetailsList,
        transportCost: this.transportCost,
        totalOff: this.totalOff
      }
      this.generateFactor(sendObject).then((res) => {
        if (res[0].BuyNum !== undefined) {
          this.$q.notify({
            type: 'positive',
            color: 'positive',
            position:'top',
            message: `فاکتور خرید به شماره ${res[0].BuyNum} ثبت گردید`
          })
          this.$emit('generated-factory', res)
        } else {
          this.$q.notify({
            type: 'negative',
            color: 'negative',
            position:'top',
            message: 'خطا در صدور فاکتور'
          })
        }
      });
    },
    showProductDetailsDialog(row) {
      this.getProductInfo(row.Goods_ID).then((res) => {
        this.selectedProductDetails = res[0];
        this.showProductDetails = true
      })
    },
  },
  watch:{
    tax:function (value){
      if (!isNaN(value)){
        this.OrderDetailsList.forEach(item=>{
          item.SaleG_Tax =  (item.SaleG_PricePure * this.tax) / 100.00
          item.SaleG_Tax_D = this.tax;

        })
      }
    }
  },
  created() {
    this.getDetails({buyNum: this.orderInfo.Buy_Num, buyKind: this.orderInfo.Buy_Kind}).then((res) => {
      this.OrderDetailsList = res
      this.groupedList = this.lodash(this.OrderDetailsList).filter(item => item.Goods_Group !== 86).groupBy('Group_Name')
          .map(function (items, Group_Name) {
            return {
              Group_Name: Group_Name,
              sum: items.map(item => item.SaleG_TotalAll).reduce((accumulator, curr) => accumulator + curr),
            };
          }).value();
    });
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>